export default "__VITE_ASSET__D1VB2cTS__"